import { Navigation, CustomThemesDashboard } from 'components'

export const CustomThemes = () => {
  return (
    <>
      <Navigation />
      <CustomThemesDashboard />
    </>
  )
}

export default CustomThemes
